import {
  AlignLeft,
  FileText,
  FolderTree,
  Grid3x3,
  Image,
  Layers,
  ListTree,
  Package,
  Palette,
  Ruler,
  Shirt,
  SlidersHorizontal,
  Sparkles,
  Star,
  Tag,
  Type,
  Users,
  type LucideIcon,
} from 'lucide-react';

import type { NewRunFieldGroup } from './new-run-field-groups';

/** One recognisable icon per enrichment field code, so a long field list scans by shape. */
const ICON_BY_CODE: Record<string, LucideIcon> = {
  TITLE: Type,
  DESCRIPTION: AlignLeft,
  STRUCTURED_DESCRIPTION: ListTree,
  PRODUCT_HIGHLIGHT: Star,
  PRODUCT_HIGHLIGHTS: Star,
  CARE_INSTRUCTION: Shirt,
  CARE_INSTRUCTIONS: Shirt,
  PRODUCT_TYPE: Tag,
  GOOGLE_PRODUCT_CATEGORY: FolderTree,
  AGE_GROUP: Users,
  GENDER: Users,
  MATERIAL: Layers,
  COLOR: Palette,
  COLOUR: Palette,
  SIZE: Ruler,
  PATTERN: Grid3x3,
  ADDITIONAL_IMAGE_RECOMMENDATION: Image,
  BUNDLE_SUGGESTIONS: Package,
};

/** The heading icon for each field group in a grouped field list. */
export const FIELD_GROUP_ICON: Record<NewRunFieldGroup, LucideIcon> = {
  content: FileText,
  classification: FolderTree,
  attributes: SlidersHorizontal,
  media: Image,
  other: Sparkles,
};

/** A field code's icon; a code this app hasn't seen yet falls back to the generic sparkle. */
export function fieldIconOf(code: string): LucideIcon {
  return ICON_BY_CODE[code.toUpperCase()] ?? Sparkles;
}
